export enum FakeSaleStatus {
	None = 0,
	Reservation = 410,
	Sold = 610
}
